import type { KeyState } from '../keyState';

export function StatusBadge({ state }: { state: KeyState }) {
  const title = state.issues.map((i) => i.detail).join(' ');
  return (
    <span className={`badge badge-${state.severity}`} title={title || 'No known problems.'}>
      {state.label}
    </span>
  );
}

export function UnmanagedBadge() {
  return (
    <span
      className="badge badge-unmanaged"
      title="Found in the OpenRouter workspace with no owner recorded in this app. Needs an admin to claim or disable it."
    >
      Unclaimed
    </span>
  );
}
